import { ApiClient } from "client/base";
import { delay } from "utils/promise";
const POLL_INTERVAL_MS = 1000;
export class CloudAnalyticsClient extends ApiClient {
    pollAsyncProcess(id, fetch) {
        return fetch(id).then((result) => {
            if (result.status == "INPROGRESS") {
                return delay(POLL_INTERVAL_MS).then(() => this.pollAsyncProcess(id, fetch));
            }
            return result;
        });
    }
    getAnalytics(id) {
        return this.base.get(`v1/metrics/${id}`).then((result) => {
            if (result.status == "INPROGRESS") {
                return delay(5000).then(() => this.pollAsyncProcess(result.id, this.getAnalytics.bind(this)));
            }
            return result;
        });
    }
    fetchAnalytics(skipCache = false) {
        let url = `v1/metrics`;
        if (!skipCache) {
            const cacheTime = ((Date.now() - 1000 * 60 * 60 * 24 * 7) / 1000).toString();
            url += `?cache_cutoff=${cacheTime}`;
        }
        return this.base.post(url).then((result) => {
            if (result.status == "INPROGRESS") {
                return delay(5000).then(() => this.pollAsyncProcess(result.id, this.getAnalytics.bind(this)));
            }
            return result;
        });
    }
}
